import { combineReducers } from "redux";
import { authenticationReducer } from "./authentication/authenticationReducer";
import { userReducer } from "./user/userReducer";
import { dashboardReducer } from "./dashboard/dashboardReducer";
import { analyticsReducer } from "./analytics/analyticsReducer";
import { performanceReducer } from "./performance/performanceReducer";
import { adminReducer } from "./admin/adminReducer";
import { networkreducer } from "./network/networkreducer";

const reducers = combineReducers({
    admin: adminReducer,
    authentication: authenticationReducer,
    user: userReducer,
    dashboard: dashboardReducer,
    analytics: analyticsReducer,
    network: networkreducer,
    performance: performanceReducer
});

export default reducers;
